package org.moxultimate.topwithmox.components.image

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw



@Composable
fun SocialIcon(
    iconUrl: String,
    link: String,
    description: String = "",
    wideIcon: Boolean = false,
) {
    val modifier = if (wideIcon) {
        Modifier.width(clamp(min = 80.px, value = 3.5.vw, max = 180.px))
    } else {
        Modifier.width(clamp(min = 60.px, value = 3.vw, max = 150.px))
    }

    Box(
        modifier = PressableIconStyle.toModifier()
            .onClick {
                window.open(link, "_blank")
            },
        contentAlignment = Alignment.Center,
    ) {
        Image(
            src = iconUrl,
            description = description,
            modifier = modifier.height(clamp(min = 60.px, value = 3.vw, max = 150.px))
        )
    }
}

val PressableIconStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("cursor", "pointer")
            property("transition", "transform 0.15s ease, opacity 0.15s ease")
        }
    }
    hover {
        Modifier.styleModifier {
            property("transform", "scale(1.04)")
        }
    }
    active {
        Modifier.styleModifier {
            property("transform", "scale(0.93)")
            property("opacity", "0.85")
        }
    }
}